import { Dispatch, SetStateAction, useState } from 'react';
import { UploadType } from '../../../../../consts/uploadType';
import { GeorefData, UploadData } from '../../../../../store/uploadStore';
import { ScheduledFlight } from '../../../../../types';
import { guessScanUploadType } from '../../helpers/scope';

export interface UploadTypeState {
  showTypeSelect: boolean;
  uploadType: UploadType;
  setUploadType: Dispatch<SetStateAction<UploadType>>;
}

export const useUploadType = (
  upload: UploadData | undefined,
  georef: GeorefData | undefined,
  schedule: ScheduledFlight | undefined,
  isPano: boolean,
): UploadTypeState => {
  // If it's a schedule, guess the upload type based on the scope and accuracy
  const guessedUploadType = schedule
    ? guessScanUploadType(schedule.scope, schedule.imageryGeolocationalAccuracy, georef)
    : UploadType.RegularAndRtk;

  const [uploadType, setUploadType] = useState(upload?.meta.type ?? guessedUploadType);

  if (isPano) {
    return {
      showTypeSelect: false,
      uploadType: UploadType.Pano,
      setUploadType,
    };
  }

  // If there is already an upload, we won't allow to change the type half-way without cancelling it first
  if (upload) {
    return {
      showTypeSelect: true,
      uploadType: upload.meta.type,
      setUploadType,
    };
  }

  // For new uploads, allow selection with suggested default
  return {
    showTypeSelect: true,
    uploadType,
    setUploadType,
  };
};
